<template>
  <div class="lg:flex">
    <div class="lg:w-1/2 my-auto text-center justify-center items-center">
          <p class="block text-gray-900">
            Neu bei homeface
             <span><i class="fas fa-lock text-teal-400"></i></span>
          </p>
          <div>
            <router-link
              to="/register"
              class="bg-teal-400 py-2 px-4 inline-block align-baseline font-semibold text-sm rounded text-white hover:text-blue-darker hover:bg-white hover:text-teal-400"
            >{{ $t('Register')}}</router-link>
          </div>
    </div>
    <div class="bg-white lg:w-1/2 shadow-md rounded px-8 pt-6 pb-8 mb-4 flex flex-col">
    <p class="text-xl text-gray-900 py-2 font-semibold">
      Ich habe ein Kundenkonto bei homeface
      <span><i class="fas fa-lock text-teal-400"></i></span>
      </p>
      <ValidationObserver v-slot="{ invalid }">
        <form action="#" @submit.prevent="login">
          <div class="mb-4">
            <ValidationProvider name="E-mail" rules="required|email" v-slot="{ errors }">
              <label
                class="block text-grey-darker text-sm font-semibold mb-2"
                for="username"
              >{{ $t('Email') }}</label>
              <input
                class="outline-none border rounded w-full py-2 px-3 text-grey-darker focus:border-teal-400"
                id="email"
                type="email"
                placeholder
                v-model.trim="email"
              />
              <span class="text-sm text-red-500">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class>
            <ValidationProvider name="Password" rules="required" v-slot="{ errors }">
              <label
                class="block text-grey-darker text-sm font-semibold mb-2"
                for="password"
              >{{ $t('Password') }}</label>
              <input
                class="outline-none border border-red rounded w-full py-2 px-3 text-grey-darker mb-3 focus:border-teal-400"
                id="password"
                type="password"
                placeholder
                v-model.trim="password"
              />
              <span class="text-sm text-red-500">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div v-if="errors" class="py-2">
            <span class="text-red-500 font-semibold">{{ errors }}</span>
          </div>
          <div class="float-right">
            <button
              class="outline-none bg-teal-400 hover:bg-blue-dark text-white font-semibold py-2 px-4 rounded hover:bg-white hover:text-teal-400"
              type="submit"
              :disabled="invalid"
            >{{ $t('SignIn') }}</button>
          </div>
          <div class="pt-4">
          <router-link to="/password/email" class="text-teal-400">
            {{ $t('ForgotPassword')}}
            <i class="fa fa-question"></i>
          </router-link>
        </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      email: "",
      password: "",
      submitted: false,
      errors: "",
    };
  },

  methods: {
    login() {
      this.$store
        .dispatch("login", {
          email: this.email,
          password: this.password,
        })
        .then((response) => {
          this.errors = response.data.message;
          if (!this.errors) {
            this.$notify({
              group: "auth",
              text: "Benutzer hat sich erfolgreich angemeldet.",
            });
            // console.log(this.$route.query.redirect);
            if (!this.$route.query.redirect) {
              this.$router.push("/");
            } else {
              this.$router.push(this.$route.query.redirect);
            }
          }
        })
        .catch((error) => console.log(error));
    },
  },
};
</script>

<style>
</style>